import React from 'react'
import { Link, useParams } from 'react-router-dom'
import home_task from '../assets/home_task.svg'
import { useHistory } from 'react-router-dom'
import arrow_project from '../assets/arrow_project.svg'
import PREVIOUS from '../assets/PREVIOUS.svg'
import category_large from '../assets/category_large.svg'
function CategoryNavigation({ projectName, taskName, projectID, taskID}) {
    const history = useHistory();
    const handleClick = () => {
        history.push({
          pathname: '/task/' + projectID,
        })
      }
  return (
    <>
            <div className='navigation-task'>
                <Link to="/" className='link-navigation'>
                    <p>
                        <img src={home_task} alt="home" className="home" />
                        &nbsp;
                        <span className='home-task' >Projects</span>
                        &nbsp; &nbsp;
                    </p>
                </Link>
                <p>
                    <img src={arrow_project} alt="home" className="home" />
                    &nbsp; &nbsp;
                    <span style={{cursor:'pointer'}} onClick={()=>handleClick()} className='home-task link-navigation' >{projectName}</span>
                    &nbsp; &nbsp;
                    <img src={arrow_project} alt="home" className="home" />
                    &nbsp; &nbsp;
                    <span  className='project-task' >{taskName}</span>
                </p>
            </div>
            <div className="project-container-task">
                <div className='project-name-task' >
                    <img src={category_large} alt="project" />
                    &nbsp; &nbsp;
                   {taskName}
                </div>
                <div className='back-arrow-task'>
                    <Link to={"/task/"+projectID}>
                        <img src={PREVIOUS} alt="PREVIOUS" className="PREVIOUS" />
                    </Link>
                </div>
            </div>
        </>
  )
}

export default CategoryNavigation